/**
 * @generated SignedSource<<0f82ad78b6c751133d406036d896366c>>
 * @relayHash 60e582676b80df79b1fb3dc82879bad6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 436baa522c1360d0a5a6fed1d1b00df78b1e41b55db8f3f7b91e09b2c8c57539

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AgentContextQuery } from './AgentContextQuery.graphql';

const node: PreloadableConcreteRequest<AgentContextQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "436baa522c1360d0a5a6fed1d1b00df78b1e41b55db8f3f7b91e09b2c8c57539",
    "metadata": {},
    "name": "AgentContextQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
